const options = {
    rootClass: 'zp_parallax_slider'
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);

    class ParallaxSlider {

        constructor(root) {
            // this.start(root);
        }

        start(root) {

            if (document.referrer != "" ||
                document.referrer.indexOf(location.protocol + "//" + location.host) === 0 ||
                window.innerWidth <= 650) {

                $('html').addClass("zp-start-parallaxslider");
                this.initDotsLoader(root);
                this.animateImagesOnLoad(root);

            }
            else {

                let slickSlider = $('#' + root.attr('id') + '.zp_parallax_slider .slick-slider');
                slickSlider.slick('slickPause');

                //TODO Event-Listener für des Preloader
                // $(d).on("zp-start-parallaxslider", () => {

                    slickSlider.slick('slickPlay');
                    $('html').addClass("zp-start-parallaxslider");

                    this.initDotsLoader(root);
                    this.animateImagesOnLoad(root);

                // });

            }

            this.changedTextboxHeight(root);
            this.initSlideArrows(root);
            this.initEvents(root);

        }

        initEvents(root) {


            _w.on('scroll', () => {

                // let windowHeight = _w.height();
                // let scrollTop = _w.scrollTop();
                //
                // let parallaxSlider = $('#' + root.attr('id') + '.zp_parallax_slider');
                // parallaxSlider.css('height', 'calc(100vh + '+scrollTop+'px');

            });

            _w.on('resize', () => {

                setTimeout(() => {
                    this.changedTextboxHeight(root);
                }, 100);

                setTimeout(() => {
                    this.changedTextboxHeight(root);
                }, 200);

            });

            _w.on('mousemove', (event) => {

                if (window.innerWidth > 769 && !$('html').hasClass('zp-touch')) {
                    this.arrowVisibility(root, event.pageX);
                }

            });

        }

        changedTextboxHeight (root) {

            // let parallaxElement = $('#' + root.attr('id') + '.zp_parallax_slider .zp_parallax_slider_element');
            //
            // parallaxElement.each(function( index ) {
            //
            //     let _this = $(this);
            //     let textbox = $('#' + _this[0].id + ' .zp_parallax_slider_box');
            //     let sliderContainer = $('#' + _this[0].id + ' .zp_parallax_slider_container');
            //
            //     if (textbox.length != 0) {
            //
            //         let windowWidth = window.innerWidth;
            //
            //         if (windowWidth < 769) {
            //
            //             let textboxHeight = textbox.outerHeight();
            //             let windowHeight = _w.outerHeight();
            //
            //             sliderContainer.css('height', (windowHeight-textboxHeight));
            //
            //         }
            //         else {
            //             sliderContainer.css('height', '100%');
            //         }
            //
            //     }
            //
            // });


            // root.imagesLoaded( () => {
            //
            // });

        }

        animateImagesOnLoad (root) {

            const parallaxSlider = $('#' + root.attr('id') + '.zp_parallax_slider');
            const parallaxImage = $('#' + root.attr('id') + '.zp_parallax_slider .zp_parallax_slider_container_content');
            const textbox = $('#' + root.attr('id') + '.zp_parallax_slider .zp_parallax_slider_box');
            const additionalImage = $('#' + root.attr('id') + '.zp_parallax_slider .zp_parallax_slider_additional_image_link');

            // root.imagesLoaded( () => {

                parallaxImage.addClass('all-parallax-slider-images-loaded');
                textbox.addClass('all-parallax-slider-images-loaded');
                additionalImage.addClass('all-parallax-slider-images-loaded');

            // });

        }

        arrowVisibility (root, mousePositionX) {

            const parallaxSlider = $('#' + root.attr('id') + '.zp_parallax_slider');
            const arrowPrev = $('#' + root.attr('id') + '.zp_parallax_slider .slick-arrow.slick-prev');
            const arrowNext = $('#' + root.attr('id') + '.zp_parallax_slider .slick-arrow.slick-next');


            if (mousePositionX >= 0 && mousePositionX <= 350)
                arrowPrev.addClass('arrow-visible');
            else
                arrowPrev.removeClass('arrow-visible');
            if (mousePositionX <= window.innerWidth && mousePositionX >= (window.innerWidth-350))
                arrowNext.addClass('arrow-visible');
            else
                arrowNext.removeClass('arrow-visible');

        }

        initDotsLoader (root) {

            $('#' + root.attr('id') + ' .slick-dots-container').ready( () => {

                let slickSlider = $('#' + root.attr('id') + '.zp_parallax_slider .slick-slider');
                let dotsUl = $('#' + root.attr('id') + ' .slick-dots-container');
                let dots = $('#' + root.attr('id') + ' .slick-dots-container ul li');

                let autoplaySpeed = root.data( "autoplay-speed" );
                let dotsLength = dots.length;
                let dotDelay = ((autoplaySpeed/dotsLength)/6);

                let dotDelayPreTime = 0;
                dots.each((index, dot) => {

                    let _dot = $(dot);

                    _dot.append('<div class="slick-dot-loader-container slick-dot-loader-container-'+index+'"></div>');
                    let _dotLoaderContainer = $('#' + root.attr('id') + ' .slick-dots-container ul li .slick-dot-loader-container-'+index);

                    //Alle Dots, außer die letzten
                    if (dotsLength != index+1) {

                        //Mittlere Dots bei ungerader Anzahl an Dots
                        if (dotsLength%2 != 0 &&
                            Math.ceil(dotsLength / 2)-2 == index ||
                            dotsLength%2 != 0 &&
                            Math.ceil(dotsLength / 2)-1 == index)
                        {
                            if (Math.ceil(dotsLength / 2)-2 == index) {
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-1 slick-dot-loader-' + (index + 1) + '-1" style="transition-delay: ' + (dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-2 slick-dot-loader-' + (index + 1) + '-2" style="transition-delay: ' + (dotDelay + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-3 slick-dot-loader-' + (index + 1) + '-3" style="transition-delay: ' + ((dotDelay * 2) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-4 slick-dot-loader-' + (index + 1) + '-4" style="transition-delay: ' + ((dotDelay * 3) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-5 slick-dot-loader-' + (index + 1) + '-5" style="transition-delay: ' + ((dotDelay * 4) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-6 slick-dot-loader-' + (index + 1) + '-6" style="transition-delay: ' + ((dotDelay * 5) + dotDelayPreTime) + 'ms"></div>');
                            }
                            else if (Math.ceil(dotsLength / 2)-1 == index) {
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-1 slick-dot-loader-' + (index + 1) + '-1" style="transition-delay: ' + (dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-2 slick-dot-loader-' + (index + 1) + '-2" style="transition-delay: ' + (dotDelay + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-3 slick-dot-loader-' + (index + 1) + '-3" style="transition-delay: ' + ((dotDelay * 2) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-4 slick-dot-loader-' + (index + 1) + '-4" style="transition-delay: ' + ((dotDelay * 3) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-5 slick-dot-loader-' + (index + 1) + '-5" style="transition-delay: ' + ((dotDelay * 4) + dotDelayPreTime) + 'ms"></div>');
                                _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-6 slick-dot-loader-' + (index + 1) + '-6" style="transition-delay: ' + ((dotDelay * 5) + dotDelayPreTime) + 'ms"></div>');
                            }
                        }

                        //Mittlere Dots bei gerader Anzahl an Dots
                        else if (dotsLength%2 == 0 &&
                            dotsLength/2 == index+1)
                        {
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-1 slick-dot-loader-'+(index+1)+'-1" style="transition-delay: '+(dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-2 slick-dot-loader-'+(index+1)+'-2" style="transition-delay: '+(dotDelay+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-3 slick-dot-loader-'+(index+1)+'-3" style="transition-delay: '+((dotDelay*2)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-4 slick-dot-loader-'+(index+1)+'-4" style="transition-delay: '+((dotDelay*3)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-5 slick-dot-loader-'+(index+1)+'-5" style="transition-delay: '+((dotDelay*4)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader-hover-hidden slick-dot-loader slick-dot-loader-6 slick-dot-loader-'+(index+1)+'-6" style="transition-delay: '+((dotDelay*5)+dotDelayPreTime)+'ms"></div>');
                        }

                        //Alle anderen Dots
                        else {
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-1 slick-dot-loader-'+(index+1)+'-1" style="transition-delay: '+(dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-2 slick-dot-loader-'+(index+1)+'-2" style="transition-delay: '+(dotDelay+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-3 slick-dot-loader-'+(index+1)+'-3" style="transition-delay: '+((dotDelay*2)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-4 slick-dot-loader-'+(index+1)+'-4" style="transition-delay: '+((dotDelay*3)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-5 slick-dot-loader-'+(index+1)+'-3" style="transition-delay: '+((dotDelay*4)+dotDelayPreTime)+'ms"></div>');
                            _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-6 slick-dot-loader-'+(index+1)+'-4" style="transition-delay: '+((dotDelay*5)+dotDelayPreTime)+'ms"></div>');
                        }
                    }

                    //Die letzten Dots
                    else {
                        _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-1 slick-dot-loader-'+(index+1)+'-1" style="transition-delay: '+(+dotDelayPreTime)+'ms"></div>');
                        _dotLoaderContainer.append('<div class="slick-dot-loader slick-dot-loader-2 slick-dot-loader-'+(index+1)+'-2" style="transition-delay: '+(dotDelay+dotDelayPreTime)+'ms"></div>');
                    }
                    dotDelayPreTime = dotDelayPreTime+(dotDelay*6);

                });

                let dotsLoader = $('#' + root.attr('id') + ' .slick-dots-container ul li .slick-dot-loader');

                let imageLocation = $('#' + root.attr('id') + ' .zp_parallax_slider_imagelocation').text();

                dotsUl.append(
                    '<div class="slick-dots-play-pause-container">' +
                    '<div class="slick-dots-play-pause slick-dots-play active">' +
                    '<img src="'+imageLocation+'stop.svg">' +
                    '</div>' +
                    '<div class="slick-dots-play-pause slick-dots-pause">' +
                    '<img src="'+imageLocation+'play.svg">' +
                    '</div>' +
                    '</div>'
                );

                let playPauseButton = $('#' + root.attr('id') + ' .slick-dots-play-pause-container');
                let playButton = $('#' + root.attr('id') + ' .slick-dots-play');
                let pauseButton = $('#' + root.attr('id') + ' .slick-dots-pause');
                let hiddenDots = $('#' + root.attr('id') + ' .slick-dot-loader-hover-hidden');

                playPauseButton.on('click', (event) => {
                    if (playButton.hasClass('active')) {
                        playButton.removeClass('active');
                        pauseButton.addClass('active');
                        slickSlider.slick('slickPause');
                        dotsLoader.removeClass('load');
                        hiddenDots.addClass('pause');
                    }

                    else if (pauseButton.hasClass('active')) {
                        pauseButton.removeClass('active');
                        playButton.addClass('active');
                        slickSlider.slick('slickPlay');
                        slickSlider.slick('slickNext');
                        dotsLoader.addClass('load');
                        hiddenDots.removeClass('pause');
                    }

                });

                //TODO: Nicht genau genug
                setTimeout ( () => {
                    dotsLoader.addClass('load');
                }, (dotDelay*2));

                slickSlider.on('afterChange', () => {
                    if (playButton.hasClass('active')) {

                        dotsLoader.removeClass('load');
                        setTimeout ( () => {
                            dotsLoader.addClass('load');
                        }, (dotDelay*2));

                    }
                });

            });



        }

        initSlideArrows (root) {

            $('#' + root.attr('id') + ' .slick-arrow').ready( () => {

                let slickArrows = $('#' + root.attr('id') + ' .slick-arrow');
                slickArrows.empty();
                slickArrows.append(
                    '<div class="slick-arrow_button_arrow">' +
                    '<div class="slick-arrow_line slick-arrow_line_left"></div>' +
                    '<div class="slick-arrow_line slick-arrow_line_center"></div>' +
                    '<div class="slick-arrow_line slick-arrow_line_right"></div>' +
                    '</div>'
                );

            });

        }

    }

    return ParallaxSlider;

}(window, document, jQuery)));